import { Component } from '@angular/core';

/**
 * This class represents the lazy loaded HomeComponent.
 */
@Component({
    selector: 'sd-home',
    templateUrl: 'home.component.html',
    standalone: false
})

export class HomeComponent {


  /**
   */
  constructor() {}

}
